import { ReactNode } from "react";

import { Text } from "@design-system/Text/Text";

import classes from "./DashboardWindowBar.module.css";

type Props = {
  label: string;
  actions?: ReactNode;
};

/** One window control above every widget that shares that range. */
export const DashboardWindowBar = ({ label, actions }: Props) => {
  return (
    <div className={classes.bar}>
      <Text size={12} color="textSecondary">
        {label}
      </Text>
      {actions ? <div className={classes.actions}>{actions}</div> : null}
    </div>
  );
};
